<template>
  <b-modal
    id="teacherValidation"
    no-close-on-esc
    hide-footer
    centered
    size="md"
    header-close-variant="dark"
    title="استاد جدید"
    @hidden="
      model.phoneNumber = ''
      model.nationalCode = ''
      codeErr = false
      mobileErr = false
      submit = false
    "
  >
    <div class="my-3">
      <BaseText
        :maxlength="2000"
        :value="model.phoneNumber"
        @input="model.phoneNumber = $event"
        :required="true"
        :showError="submit && (!model.phoneNumber || mobileErr)"
        errortext="تلفن همراه را به درستی وارد کنید."
        title="تلفن همراه *"
        placeholder="تلفن همراه"
      />
    </div>
    <div class="my-3">
      <BaseText
        :maxlength="2000"
        :value="model.nationalCode"
        @input="model.nationalCode = $event"
        :required="true"
        :showError="submit && (!model.nationalCode || codeErr)"
        errortext="کد ملی را به درستی وارد کنید."
        title="کد ملی *"
        placeholder="کد ملی"
      />
    </div>
    <div class="pt-3 d-flex flex-row justify-content-end">
      <b-button @click="$bvModal.hide('teacherValidation')">انصراف</b-button>
      <Button :loading="loading" text="جستجو" btnClass="upload-btn btn-border" @click.native="searchTeacher">جستجو</Button>
    </div>
  </b-modal>
</template>
<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
import moocTeacherProvider from '../../../services/mooc/teacher'
import Button from '../../common/Button.vue'

export default {
  components: { BaseText, Button },
  data() {
    return {
      model: {
        phoneNumber: '',
        nationalCode: '',
      },
      submit: false,
      loading: false,
      codeErr: false,
    }
  },
  methods: {
    async searchTeacher() {
      try {
        this.loading = true
        this.submit = true
        this.codeErr = false
        this.mobileErr = false
        if (!/^[0-9]{10}$/.test(this.model.nationalCode)) {
          this.codeErr = true
        }
        if (!/^(\+98|0)?9\d{9}$/.test(this.model.phoneNumber)) {
          this.mobileErr = true
        }
        if (this.mobileErr || this.codeErr) {
          this.loading = false
          return false
        }
        if (!this.model.phoneNumber || !this.model.nationalCode) {
          this.loading = false
          return false
        }
        const req = await moocTeacherProvider.searchTeacher(this.model)
        if (req.status === 200) {
          this.loading = false
          this.submit = false

          if (req?.data?.data?.output?.id > 0) {
            this.$router.push('/list/' + this.$route.params.slug + '/detail/' + req.data.data.output.id)
          } else if (req?.data?.data?.output?.id === 0) {
            this.$router.push({
              query: {
                ...this.$route.query,
                phone: req.data.data.output.phoneNumber,
                code: req.data.data.output.nationalCode,
              },
              path: '/list/' + this.$route.params.slug + '/add',
            })
          }
        }
      } catch (error) {
        this.loading = false
        this.submit = false
      }
    },
  },

  mounted() {
    this.model.phoneNumber = ''
    this.model.nationalCode = ''
  },
}
</script>
<style lang="scss" scoped>
.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}
</style>
